import { useEffect } from 'react';
import { useUser } from '@clerk/react';

function SalesIQIdentity() {
  const { isSignedIn, user } = useUser();

  useEffect(() => {
    // Only proceed if user has granted full consent for tracking
    const consent = localStorage.getItem('cookie-consent');
    if (consent !== 'all') return;

    const zoho = window.$zoho;
    if (!zoho || !zoho.salesiq) return;

    const language = navigator.language || navigator.userLanguage;

    const originalReady = zoho.salesiq.ready;
    zoho.salesiq.ready = function () {
      if (typeof originalReady === 'function') originalReady();

      if (language) {
        zoho.salesiq.language(language);
      }

      if (isSignedIn && user) {
        zoho.salesiq.visitor.name(user.fullName || '');
        zoho.salesiq.visitor.email(
          user.primaryEmailAddress?.emailAddress || ''
        );
      }
    };

    // If SalesIQ has already loaded, apply settings directly
    if (zoho.salesiq.visitor) {
      if (language) {
        try { zoho.salesiq.language(language); } catch (_) {}
      }
      if (isSignedIn && user) {
        try {
          zoho.salesiq.visitor.name(user.fullName || '');
          zoho.salesiq.visitor.email(
            user.primaryEmailAddress?.emailAddress || ''
          );
        } catch (_) {}
      }
    }
  }, [isSignedIn, user]);

  return null;
}

export default SalesIQIdentity;
